import mesh from './mesh/store';
import block from './block/store';
import nav from './nav/store';
import retrieval from './retrieval/store';

export default {
  namespaced: true,
  modules: { mesh, block, nav, retrieval },
};
